import { http, HttpResponse } from "msw";

import { waitForMockLatency } from "@/mocks/latency";

const GOOGLE_TAG_MANAGER_URL = "https://www.googletagmanager.com/*";

export const createAnalyticsHandlers = () => {
  return [
    http.get(GOOGLE_TAG_MANAGER_URL, async () => {
      await waitForMockLatency();

      return new HttpResponse("", {
        headers: { "Content-Type": "application/javascript" },
      });
    }),
  ];
};
